import { render, staticRenderFns } from "./form-richiesta-assistenza.vue?vue&type=template&id=b7598e38&scoped=true"
import script from "./form-richiesta-assistenza.vue?vue&type=script&lang=js"
export * from "./form-richiesta-assistenza.vue?vue&type=script&lang=js"
import style0 from "./form-richiesta-assistenza.vue?vue&type=style&index=0&id=b7598e38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7598e38",
  null
  
)

export default component.exports